export * from './delete-projekt-art-request.interface';
export * from './delete-projekt-art-response.interface';
export * from './delete-projekt-art.shapes';
